import React, { useState } from "react";
import bessieCooper from "../../assets/images/today-workflow/bessie_cooper_img.svg";
import { ProfileEditIcon } from "../common/Icon";
import WorkflowProfileInformation from "./WorkflowProfileInformation";
import WorkflowProfileConnected from "./WorkflowProfileConnected";
import WorkflowProfileFollowUp from "./WorkflowProfileFollowUp";
import WorkflowProfileMeeting from "./WorkflowProfileMeeting";
import WorkflowProfileContactLog from "./WorkflowProfileContactLog";
import { useStateProvider } from "../common/StateProvider";
import WorkflowProfileNote from "./WorkflowProfileNote";

const TodayWorkflowItemProfile = ({ setProfileToggle }) => {
  const { todaysWorkflowProfile } = useStateProvider();
  const [workflowTeamProfileTab, setWorkflowTeamProfileTab] =
    useState("information"); //TODAY WORKFLOW ITEM PROFILE TAB
  return (
    <>
      <div className="rounded-[30px] bg-white md:max-w-[652px] w-full md:w-[652px] pb-5">
        <div className="flex items-center gap-5 pt-5 pl-6">
          <div className=" relative">
            <img
              className="w-[73px] h-[73px]"
              src={todaysWorkflowProfile.newContactImg}
              alt="bessieCooper"
            />
            <button className="absolute right-0 bottom-0 bg-white shadow-profile_edit_button_shadow rounded-full w-[22px] h-[22px] p-1 hover:bg-[#8536EA] profile_edit_button duration-200 ">
              <ProfileEditIcon />
            </button>
          </div>
          <p className="ff_inter text-base font-normal text-black">
            {todaysWorkflowProfile.newContactNameText}
          </p>
        </div>
        <div className=" overflow-x-auto  w-[320px]  xs:w-[375px] min-[400px]:w-full">
          <div className="flex pt-2 w-full">
            <button
              onClick={() => setWorkflowTeamProfileTab("information")}
              className={`text-gray text-xs 3xl:text-[14px] font-normal py-[14px] px-2 whitespace-nowrap md:px-[22px] border-b-[1px] border-solid border-[rgba(0,_0,_0,_0.20)] md:w-full  ${
                workflowTeamProfileTab === "information"
                  ? " text-primary !border-b-[3px] border-solid !border-primary !opacity-100 stroke-2"
                  : ""
              } `}>
              Information
            </button>
            <button
              onClick={() => setWorkflowTeamProfileTab("connected")}
              className={`text-gray text-xs 3xl:text-[14px] font-normal py-[14px] px-2 whitespace-nowrap md:px-[22px] border-b-[1px] border-solid border-[rgba(0,_0,_0,_0.20)] md:w-full ${
                workflowTeamProfileTab === "connected"
                  ? " text-primary !border-b-[3px] border-solid !border-primary !opacity-100 stroke-2"
                  : ""
              }`}>
              Connected
            </button>
            <button
              onClick={() => setWorkflowTeamProfileTab("profileFollowUp")}
              className={`text-gray text-xs 3xl:text-[14px] font-normal py-[14px] px-2 whitespace-nowrap md:px-[22px] border-b-[1px] border-solid border-[rgba(0,_0,_0,_0.20)] md:w-full ${
                workflowTeamProfileTab === "profileFollowUp"
                  ? " text-primary !border-b-[3px] border-solid !border-primary !opacity-100 stroke-2"
                  : ""
              }`}>
              Follow Up
            </button>
            <button
              onClick={() => setWorkflowTeamProfileTab("profileMeeting")}
              className={`text-gray text-xs 3xl:text-[14px] font-normal py-[14px] px-2 whitespace-nowrap md:px-[22px] border-b-[1px] border-solid border-[rgba(0,_0,_0,_0.20)] md:w-full ${
                workflowTeamProfileTab === "profileMeeting"
                  ? " text-primary !border-b-[3px] border-solid !border-primary !opacity-100 stroke-2"
                  : ""
              }`}>
              Meeting
            </button>
            <button
              onClick={() => setWorkflowTeamProfileTab("contactLog")}
              className={`text-gray text-xs 3xl:text-[14px] font-normal py-[14px] px-2 whitespace-nowrap md:px-[22px] border-b-[1px] border-solid border-[rgba(0,_0,_0,_0.20)] md:w-full ${
                workflowTeamProfileTab === "contactLog"
                  ? " text-primary !border-b-[3px] border-solid !border-primary !opacity-100 stroke-2"
                  : ""
              }`}>
              Contact Log
            </button>
            <button
              onClick={() => setWorkflowTeamProfileTab("notes")}
              className={`text-gray text-xs 3xl:text-[14px] font-normal py-[14px] px-2 whitespace-nowrap md:px-[22px] border-b-[1px] border-solid border-[rgba(0,_0,_0,_0.20)] md:w-full ${
                workflowTeamProfileTab === "notes"
                  ? " text-primary !border-b-[3px] border-solid !border-primary !opacity-100 stroke-2"
                  : ""
              }`}>
              Notes
            </button>
          </div>
        </div>
        <div className="h-[calc(100vh-150px)]  md:h-[calc(100vh-195px)] 2xl:h -[calc(100vh-180px)]  3xl:h-[calc(100vh-195px)] overflow-y-auto   productivity_scrollbar_line">
          {workflowTeamProfileTab === "information" && (
            <WorkflowProfileInformation setProfileToggle={setProfileToggle} />
          )}
          {workflowTeamProfileTab === "connected" && (
            <WorkflowProfileConnected />
          )}
          {workflowTeamProfileTab === "profileFollowUp" && (
            <WorkflowProfileFollowUp />
          )}
          {workflowTeamProfileTab === "profileMeeting" && (
            <WorkflowProfileMeeting />
          )}
          {workflowTeamProfileTab === "contactLog" && (
            <WorkflowProfileContactLog />
          )}
          {workflowTeamProfileTab === "notes" && <WorkflowProfileNote />}
        </div>
      </div>
    </>
  );
};

export default TodayWorkflowItemProfile;
